@if (!isLink) {
  <button class="text-button" matButton="filled" [type]="type" [disabled]="disabled" [color]="color" [tabIndex]="tabIndex">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}
@if (routerLink) {
  <a
    class="text-button"
    matButton="filled"
    [type]="type"
    [disabled]="disabled"
    [color]="color"
    [target]="target"
    [routerLink]="routerLink"
    [tabIndex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}
@if (href) {
  <a
    class="text-button"
    matButton="filled"
    [type]="type"
    [disabled]="disabled"
    [color]="color"
    [target]="target"
    [href]="href"
    [tabIndex]="tabIndex"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}
<ng-template #content><ng-content></ng-content></ng-template>
